export default "__VITE_ASSET__C7CTvxPW__"